import { render, staticRenderFns } from "./AppProductsIcon.vue?vue&type=template&id=7471b2f8"
import script from "./AppProductsIcon.vue?vue&type=script&lang=js"
export * from "./AppProductsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports